export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#067add',
      gradientDefault2: '#067add',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://jfainformatica.com.br/image-bank/Logos.png',
  favicon: '/cadeadosd.png',
}

export const seo = {
  titulo: 'JFA Informatica',
  email: 'suporte@senhadigital.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: '61 98478-9564',
  whatsapp: '61 98478-9564',
  botaoRenocao: '61984789564',
  comercial: '61984789564',
  botaoWhatsapp: '61984789564',
  number0800: '0800 600 2710',
  cidadeuf: 'Goiás/GO',
  cidade: 'Valparaíso de Goiás',
  bairro: 'Esplanada A - Parque Esplanada III',
  titulo: 'Certificado Digital em Valparaíso de Goiás',
  rua: 'Rua 13',
  numero: 'QD 34',
  complemento: 'Lote 21, Sala 206 Edifício Comercial',
  cep: '72876-334',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da JFA',
}

export const redes = {
  facebook: 'https://www.facebook.com/jfasolucoeseminformatica',
  instagram: 'https://www.instagram.com/jfacertificacaodigital/',
  linkedin: '',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
